import { useTranslation } from "react-i18next";
import { Building2, MapPin, Ban } from "lucide-react";
import { localName } from "../../lib/localName";

// شريط النطاق: يعرض الشركة الحالية + تبويبات الفروع لتصفية الأقسام حسب الفرع.
export const DeptScopeBar = ({ company, branches, scope, onScope, counts }) => {
  const { t, i18n } = useTranslation();
  const isAr = (i18n.language || "ar").startsWith("ar");
  const cName = company?.nickname
    || (localName(company));
  const btn = (active) =>
    `flex items-center gap-1.5 rounded-2xl px-3 py-2 text-xs font-semibold transition ${
      active ? "bg-primary text-primary-foreground shadow-neu-in"
             : "bg-background shadow-neu-sm hover:-translate-y-0.5 hover:brightness-110"}`;
  return (
    <div className="mb-5 rounded-3xl border border-border/50 bg-background p-4 shadow-neu-sm"
         data-testid="dept-scope-bar">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2 rounded-2xl bg-primary/10 px-3 py-1.5 text-primary">
          <Building2 className="h-4 w-4" />
          <span className="text-sm font-bold" data-testid="scope-company">
            {cName || t("app.company")}
          </span>
        </div>
        <div className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
          <MapPin className="h-3.5 w-3.5" />
          <span>{t("departments.scope.filterByBranch")}</span>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <button onClick={() => onScope(null)} className={btn(!scope)} data-testid="scope-all">
          {t("departments.scope.all")}
          <span className="num rounded-md bg-black/10 px-1.5 font-mono text-[10px]">
            {counts.total}
          </span>
        </button>
        {branches.map((b) => (
          <button key={b.id} onClick={() => onScope(b.id)}
                  className={btn(scope === b.id)} data-testid={`scope-branch-${b.id}`}>
            <MapPin className="h-3 w-3" />
            {localName(b)}
            <span className="num rounded-md bg-black/10 px-1.5 font-mono text-[10px]">
              {counts[b.id] || 0}
            </span>
          </button>
        ))}
        {counts.unassigned > 0 ? (
          <button onClick={() => onScope("__none__")} className={btn(scope === "__none__")}
                  data-testid="scope-unassigned">
            <Ban className="h-3 w-3" />
            {t("departments.scope.unassigned")}
            <span className="num rounded-md bg-black/10 px-1.5 font-mono text-[10px]">
              {counts.unassigned}
            </span>
          </button>
        ) : null}
      </div>
    </div>
  );
};
